import React from 'react';
import { Glyphicon, NavItem, Dropdown, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
  filterProductTypes, filterTransportTypes, filterMyDeals, filterIsArchived, resetFilters,
  filterData, filterUnlinked, selectShipmentSort, filterTransportData, filterHasDispute,
  filterOperationDeals, filterPaymentsData, filterDetachedPaymentsData, filterDealCanceled,
  updateDealListSearch,
}
  from '../store/search.store.js';
import { loadOperationUsers, loadCharteringUsers, loadTraderUsers }
  from '@/store/allaround.store.js';
import { Set, Map } from 'immutable';
import AvailableSince, { VERSIONS } from '@/util/version';
import { FormControl, Button } from '../../../form/FormControls';
import sort from '@/../style/sort.png';

const menuButtonStyle = { width: '100%', textAlign: 'left' };
const dropDownStyle = {
  border: 'none',
  boxShadow: 'none',
  display: 'inline-block',
  cursor: 'pointer',
  height: '30px',
};

class FilterPanel extends React.Component {
  constructor(props) {
    super(props);
    this.selectUrea = this.selectProductTypes.bind(this, 'Urea');
    this.selectNitrate = this.selectProductTypes.bind(this, 'A/N', 'UAN');
    this.selectSulfate = this.selectProductTypes.bind(this, 'A/S');
    this.selectPhosphates = this.selectProductTypes.bind(this, 'Phosphates');
    this.selectPotash = this.selectProductTypes.bind(this, 'Potash');
    this.selectNPKs = this.selectProductTypes.bind(this, 'NPKs');
    this.selectAGRI = this.selectProductTypes.bind(this, 'AGRI');
    this.selectSulfur = this.selectProductTypes.bind(this, 'Sulfur');
    this.selectSpecialty = this.selectProductTypes.bind(this, 'Specialty');
    this.selectSolubles = this.selectProductTypes.bind(this, 'Solubles');
    this.selectOther = this.selectProductTypes.bind(this, 'Other');
    this.selectBulk = this.selectTransportTypes.bind(this, 'BULK');
    this.selectContainer = this.selectTransportTypes.bind(this, 'CONTAINER');
    this.selectRailcar = this.selectTransportTypes.bind(this, 'RAILCAR');
    this.selectTruck = this.selectTransportTypes.bind(this, 'TRUCK');
    this.selectUnlinked = this.selectUnlinked.bind(this);
    this.selectMyDeals = this.selectMyDeals.bind(this);
    this.selectArchived = this.selectArchived.bind(this);
    this.selectDispute = this.selectDispute.bind(this);
    this.selectDealCanceled = this.selectDealCanceled.bind(this);
    this.selectShipmentSort = this.selectShipmentSort.bind(this);
    this.selectOperationUser = this.selectOperationUser.bind(this);
    this.renderArchivedFilter = this.renderArchivedFilter.bind(this);
    this.myDeals = this.myDeals.bind(this);
    this.renderMyDeals = this.renderMyDeals.bind(this);
    this.renderMyTransports = this.renderMyTransports.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.resetPressed = false;
  }

  componentWillMount() {
    if (this.props.dealType === 'payments') {
      this.props.filterPaymentsData(this.props.isArchived);
    } else if (this.props.dealType === 'commonpayments') {
      this.props.filterDetachedPaymentsData();
    } else {
      this.props.filterDealData(this.props.myDeals, this.props.pTypes, this.props.dealType,
        this.props.tTypes, this.props.isArchived, this.props.dispute, this.props.operationUserId,
        this.props.dealCanceled, this.props.dealListSearch);
      this.props.loadAllOperators();
      this.props.loadAllChartering();
      this.props.loadTraderUsers();
    }
  }

  componentWillReceiveProps(props) {
    if ((this.props.isArchived != props.isArchived && props.dealType == 'payments') ||
        (props.dealType == 'payments' && this.props.dealType != 'payments')) {
      this.props.filterPaymentsData(props.isArchived);
    }
    if (props.dealType === 'commonpayments' && this.props.dealType !== 'commonpayments') {
      this.props.filterDetachedPaymentsData();
    }
    if (this.props.dealType !== props.dealType || this.props.myDeals !== props.myDeals ||
      this.props.pTypes !== props.pTypes || this.props.tTypes !== props.tTypes
      || this.props.isArchived !== props.isArchived || this.props.dispute !== props.dispute
      || this.props.operationUserId !== props.operationUserId
      || this.props.dealCanceled !== props.dealCanceled || this.resetPressed) {
      this.resetPressed = false;
      this.props.filterDealData(props.myDeals, props.pTypes,
        props.dealType, props.tTypes, props.isArchived, props.dispute, props.operationUserId,
        props.dealCanceled, props.dealListSearch);
    }
  }

  selectProductTypes(...tTypes) {
    this.props.selectProductTypes(...tTypes);
  }

  selectTransportTypes(...tTypes) {
    this.props.selectTransportTypes(...tTypes);
  }

  selectMyDeals() {
    this.props.selectMyDeals(!this.props.myDeals);
  }

  selectShipmentSort() {
    this.props.selectShipmentSort(!this.props.shipmentSort);
  }

  selectUnlinked() {
    this.props.filterUnlinked(!this.props.unlinked);
  }

  selectArchived() {
    this.props.selectArchived(!this.props.isArchived);
  }

  selectDealCanceled() {
    this.props.selectDealCanceled(!this.props.dealCanceled);
  }

  selectDispute() {
    this.props.selectDispute(!this.props.dispute);
  }

  selectOperationUser(selectedUserId, userId) {
    this.props.selectOperationUser(userId == selectedUserId ? null : userId);
  }
  resetFilters() {
    this.resetPressed = true;
    this.props.resetFilters();
  }

  myDeals(selectedId, caption, mainItem) {
    const { myDeals, operationUsers, charteringUsers, traderUsers, dealType } = this.props;
    const condition = myDeals || selectedId || selectedId == 0;
    const operationUsersRows = [];
    let usersInList = operationUsers.concat(traderUsers);
    if (dealType == 'transport') {
      usersInList = usersInList.concat(charteringUsers);
    }
    let usersInListMap = new Map();
    usersInList.filter(u => u).forEach(u => usersInListMap = usersInListMap.set(u.get('id'), u)); //eslint-disable-line
    usersInListMap = usersInListMap.sort(
      (a, b) => a.get('name', '').localeCompare(b.get('name', '')));
    usersInListMap.filter(u => u).forEach((u) => {
      operationUsersRows.push(<Button
        bsSize="xsmall"
        bsStyle={selectedId == u.get('id') ? 'primary' : undefined}
        style={menuButtonStyle}
        id={`operationsUser${u.get('id')}`}
        onClick={() => this.selectOperationUser(selectedId, u.get('id'))}
        title={`Operation user ${u.get('name')}`}
        className="my-deals-username"
      >
        {u.get('name')}
      </Button>);
    });
    return (
      <Dropdown className={condition ? 'button-selected' : ''} id="advancedMyDealsFilterDropdown">
        <Dropdown.Toggle
          className={condition ? 'button-selected' : ''}
          title={caption}
          style={dropDownStyle}
        />
        <Dropdown.Menu style={{ left: '0px' }}>
          <Button
            bsSize="xsmall"
            bsStyle={myDeals ? 'primary' : undefined}
            style={menuButtonStyle}
            id="responsibleButton"
            onClick={this.selectMyDeals}
            title="Deals which you created or are responsible for"
          >
            {mainItem}
          </Button>
          {operationUsersRows}
        </Dropdown.Menu>
      </Dropdown>);
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  };

  handleSearch = () => {
    this.props.filterDealData(this.props.myDeals, this.props.pTypes, this.props.dealType,
      this.props.tTypes, this.props.isArchived, this.props.dispute,
      this.props.operationUserId, this.props.dealCanceled, this.props.dealListSearch);
  };

  renderProductFilter(Urea, Nitrate, Phosphates, Potash, NPKs, AGRI, Sulfur, Solubles, Sulfate, Other) {
    const selected = Urea || Nitrate || Phosphates || Potash || NPKs || AGRI
      || Sulfur || Solubles || Sulfate || Other;
    return (
      <Dropdown className={selected ? 'button-selected' : ''} id="productFilterDropdown">
        <Dropdown.Toggle
          title="Product"
          className={selected ? 'button-selected' : ''}
          style={dropDownStyle}
        />
        <Dropdown.Menu
          style={{ left: '0px', overflowY: 'visible' }}
        >
          <MenuItem>
            <Button
              bsStyle={Urea ? 'primary' : undefined}
              bsSize="xsmall"
              id="ureaButton"
              style={menuButtonStyle}
              onClick={this.selectUrea}
              title="UREA"
            >
              Urea
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={Nitrate ? 'primary' : undefined}
              style={menuButtonStyle}
              id="nitrateButton"
              onClick={this.selectNitrate}
              title="A/N, A/S, ACL, CAN, CNS, UAN"
            >
              Nitrate
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={Phosphates ? 'primary' : undefined}
              style={menuButtonStyle}
              id="phosphatesButton"
              onClick={this.selectPhosphates}
              title="DAP, MAP, Phosphoric Acid, Rock Phosphate, TSP"
            >
              Phosphates
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={Potash ? 'primary' : undefined}
              style={menuButtonStyle}
              id="PotashButton"
              onClick={this.selectPotash}
              title="MOP, SOP"
            >
              Potash
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={NPKs ? 'primary' : undefined}
              style={menuButtonStyle}
              id="npkButton"
              onClick={this.selectNPKs}
              title="NP, NK, NPK, PK, NPK Blending"
            >
              NPKs
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={AGRI ? 'primary' : undefined}
              style={menuButtonStyle}
              id="agriButton"
              onClick={this.selectAGRI}
              title="AGRI"
            >
              AGRI
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={Sulfur ? 'primary' : undefined}
              style={menuButtonStyle}
              onClick={this.selectSulfur}
              id="sulfurButton"
              title="Sulfur, Sulfuric Acid"
            >
              Sulfur
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={Solubles ? 'primary' : undefined}
              style={menuButtonStyle}
              onClick={this.selectSolubles}
              id="solublesButton"
              title="Solubles"
            >
              Solubles
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={Sulfate ? 'primary' : undefined}
              style={menuButtonStyle}
              onClick={this.selectSulfate}
              id="sulfateButton"
              title="Sulfate"
            >
              Sulfate
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={Other ? 'primary' : undefined}
              style={menuButtonStyle}
              onClick={this.selectOther}
              id="otherButton"
              title="All other products"
            >
              Other
            </Button>
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderArchivedFilter() {
    const selectedButton = this.props.dispute || this.props.isArchived || this.props.dealCanceled;
    return (
      <Dropdown className={selectedButton ? 'button-selected' : ''} id="statusFilterDropdown">
        <Dropdown.Toggle
          title="Status"
          className={selectedButton ? 'button-selected' : ''}
          style={dropDownStyle}
        />
        <Dropdown.Menu
          style={{ left: '0px', overflowY: 'visible' }}
        >
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={this.props.isArchived ? 'primary' : undefined}
              style={menuButtonStyle}
              id="isArchivedButton"
              onClick={this.selectArchived}
            >
              Archived
            </Button>
          </MenuItem>
          <MenuItem>
            <Button
              bsSize="xsmall"
              bsStyle={this.props.dispute ? 'primary' : undefined}
              style={menuButtonStyle}
              id="disputeButton"
              onClick={this.selectDispute}
            >
              Dispute
            </Button>
          </MenuItem>
          {this.props.dealType != 'transport' ?
            <MenuItem>
              <Button
                bsSize="xsmall"
                bsStyle={this.props.dealCanceled ? 'primary' : undefined}
                style={menuButtonStyle}
                id="dealCanceledButton"
                onClick={this.selectDealCanceled}
              >
                Canceled
              </Button>
            </MenuItem>
            :
            ''
          }
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderMyDeals(selectedOperationId) {
    if (this.props.showMyDeals) {
      if (this.props.roles.includes('ROLE_OPERATIONS_HEAD')
        || this.props.roles.includes('ROLE_ADMIN')) {
        return this.myDeals(selectedOperationId, 'My deals', 'My deals');
      }

      return (<Button
        bsSize="xsmall"
        bsStyle={this.props.myDeals ? 'primary' : undefined}
        id="responsibleButton"
        onClick={this.selectMyDeals}
        title="Deals which you created or are responsible for"
      >
        My Deals
      </Button>);
    }
    return '';
  }

  renderMyTransports(selectedOperationId) {
    if (this.props.showMyDeals) {
      if (this.props.roles.includes('ROLE_OPERATIONS_HEAD')
        || this.props.roles.includes('ROLE_ADMIN')) {
        return this.myDeals(selectedOperationId, 'Advanced my transports', 'My Transports', 195);
      }

      return (<Button
        bsSize="xsmall"
        bsStyle={this.props.myDeals ? 'primary' : undefined}
        id="responsibleButton"
        onClick={this.selectMyDeals}
        title="Transports which you created or are responsible for"
      >
        My Transports
      </Button>);
    }
    return '';
  }

  renderSearch() {
    return (
      <div className={'filter-search'}>
        <FormControl
          type="text"
          placeholder={`Search ${this.props.selectedView == 'unlinked'
            ? 'deal' : this.props.selectedView}s...`}
          value={this.props.dealListSearch}
          onChange={(e) => this.props.updateDealListSearch(e.target.value)}
          onKeyPress={this.handleKeyPress}
        />
        <Button
          bsStyle="link"
          className="search-button"
          onClick={this.handleSearch}
        >
          <Glyphicon glyph="search" />
        </Button>
      </div>
    );
  }

  render() {
    const { dealType } = this.props;
    if (!['purchase', 'sale', 'transport', 'payments'].includes(dealType)) {
      return <div />;
    }
    const Urea = this.props.pTypes.has('Urea');
    const Nitrate = this.props.pTypes.has('UAN');
    const Phosphates = this.props.pTypes.has('Phosphates');
    const Potash = this.props.pTypes.has('Potash');
    const Sulfur = this.props.pTypes.has('Sulfur');
    const NPKs = this.props.pTypes.has('NPKs');
    const AGRI = this.props.pTypes.has('AGRI');
    const Solubles = this.props.pTypes.has('Solubles');
    const Sulfate = this.props.pTypes.has('A/S');
    const Other = this.props.pTypes.has('Other');
    const Bulk = this.props.tTypes.has('BULK');
    const Container = this.props.tTypes.has('CONTAINER');
    const Railcar = this.props.tTypes.has('RAILCAR');
    const Truck = this.props.tTypes.has('TRUCK');
    const selectedOperationId = this.props.operationUserId;

    const selected = Bulk || Container || Railcar || Truck;

    switch (this.props.dealType) {
      case 'payments':
        return (
          <AvailableSince version={VERSIONS.Harmony}>
            <div className={'deal-filters'}>
              <NavItem>
                <Button
                  bsSize="xsmall"
                  bsStyle={this.props.isArchived ? 'primary' : undefined}
                  id="paymentsArchive"
                  onClick={this.selectArchived}
                  title="Payments for archived deals"
                >
                  Archived
                </Button>
              </NavItem>
            </div>
          </AvailableSince>
        );
      case 'transport':
      case 'transportBulkPayment':
        return (<AvailableSince version={VERSIONS.Harmony}>
          <div className={'deal-filters'}>
            {this.renderSearch()}
            <NavItem>
              {this.renderMyTransports(selectedOperationId)}
              <Button
                bsSize="xsmall"
                bsStyle={this.props.unlinked ? 'primary' : undefined}
                id="unlinkedButton"
                onClick={this.selectUnlinked}
                title="Transports with no full links"
              >
                Unlinked
              </Button>
              <Dropdown
                className={selected ? 'button-selected' : ''}
                id="transportTypeFilterDropdown"
              >
                <Dropdown.Toggle
                  title="Transport"
                  className={selected ? 'button-selected' : ''}
                  style={{ ...dropDownStyle,
                  }}
                />
                <Dropdown.Menu style={{ minWidth: '93px', maxWidth: '93px', left: '0px' }}>
                  <MenuItem>
                    <Button
                      bsStyle={Bulk ? 'primary' : undefined}
                      bsSize="xsmall"
                      id="bulks"
                      style={menuButtonStyle}
                      onClick={this.selectBulk}
                    >
                      Bulk Vessel
                    </Button>
                  </MenuItem>
                  <MenuItem>
                    <Button
                      bsSize="xsmall"
                      bsStyle={Container ? 'primary' : undefined}
                      style={menuButtonStyle}
                      id="containers"
                      onClick={this.selectContainer}
                    >
                      Container
                    </Button>
                  </MenuItem>
                  <MenuItem>
                    <Button
                      bsSize="xsmall"
                      bsStyle={Railcar ? 'primary' : undefined}
                      style={menuButtonStyle}
                      id="Railcars"
                      onClick={this.selectRailcar}
                    >
                      Railcar
                    </Button>
                  </MenuItem>
                  <MenuItem>
                    <Button
                      bsSize="xsmall"
                      bsStyle={Truck ? 'primary' : undefined}
                      style={menuButtonStyle}
                      id="Trucks"
                      onClick={this.selectTruck}
                    >
                      Truck
                    </Button>
                  </MenuItem>
                </Dropdown.Menu>
              </Dropdown>
              {this.renderArchivedFilter()}
              {this.renderProductFilter(Urea, Nitrate, Phosphates, Potash, NPKs, AGRI,
                Sulfur, Solubles, Sulfate, Other)}
              <Button
                bsSize="xsmall"
                onClick={this.resetFilters}
                id="resetFiltersButton"
                title="Reset filters"
              >
                <Glyphicon
                  glyph="share-alt" className="gly-flip-horizontal"
                />
              </Button>
            </NavItem>
          </div>
        </AvailableSince>);
      case 'purchase':
      case 'sale':
        return (<AvailableSince version={VERSIONS.Harmony}>
          <div className={'deal-filters'}>
            {this.renderSearch()}
            <NavItem>
              <Button
                bsSize="xsmall"
                bsStyle={this.props.shipmentSort ? 'primary' : undefined}
                id="shipmentSortButton"
                onClick={this.selectShipmentSort}
                title="Sort deals by 'shipment to' field"
              >
                <img src={sort} alt={'Sort'} style={{ height: 12 }} /> Shipment
              </Button>
              {this.renderMyDeals(selectedOperationId)}
              <Button
                bsSize="xsmall"
                bsStyle={this.props.unlinked ? 'primary' : undefined}
                id="unlinkedButton"
                onClick={this.selectUnlinked}
                title="Deals with unlinked quantity remaining or without any linked deal"
              >
                Long/Short
              </Button>
              {this.renderArchivedFilter()}
              {this.renderProductFilter(Urea, Nitrate, Phosphates, Potash, NPKs, AGRI,
                Sulfur, Solubles, Sulfate, Other)}
              <Button
                bsSize="xsmall"
                onClick={this.resetFilters}
                id="resetFiltersButton"
                title="Reset filters"
              >
                <Glyphicon
                  glyph="share-alt" className="gly-flip-horizontal"
                />
              </Button>
            </NavItem>
          </div>
        </AvailableSince>);
      default:
        return <div />;
    }
  }
}

FilterPanel.propTypes = {
  pTypes: React.PropTypes.object,
  tTypes: React.PropTypes.object,
  operationUsers: React.PropTypes.object,
  charteringUsers: React.PropTypes.object,
  traderUsers: React.PropTypes.object,
  myDeals: React.PropTypes.bool,
  isArchived: React.PropTypes.bool,
  dispute: React.PropTypes.bool,
  dealCanceled: React.PropTypes.bool,
  dealListSearch: React.PropTypes.string,
  selectProductTypes: React.PropTypes.func,
  selectMyDeals: React.PropTypes.func,
  selectArchived: React.PropTypes.func,
  selectDispute: React.PropTypes.func,
  selectDealCanceled: React.PropTypes.func,
  resetFilters: React.PropTypes.func,
  filterDealData: React.PropTypes.func,
  filterPaymentsData: React.PropTypes.func,
  filterDetachedPaymentsData: React.PropTypes.func,
  dealType: React.PropTypes.string,
  unlinked: React.PropTypes.bool,
  filterUnlinked: React.PropTypes.func,
  shipmentSort: React.PropTypes.bool,
  selectShipmentSort: React.PropTypes.func,
  selectTransportTypes: React.PropTypes.func,
  loadAllOperators: React.PropTypes.func,
  loadAllChartering: React.PropTypes.func,
  loadTraderUsers: React.PropTypes.func,
  selectOperationUser: React.PropTypes.func,
  operationUserId: React.PropTypes.number,
  roles: React.PropTypes.string,
  showMyDeals: React.PropTypes.bool,
  updateDealListSearch: React.PropTypes.func,
  selectedView: React.PropTypes.string,
};

export default connect(((state, props) => ({
  pTypes: state.getIn(['search', props.dealType, 'filters', 'ptypes'], new Set()),
  tTypes: state.getIn(['search', props.dealType, 'filters', 'ttypes'], new Set()),
  myDeals: state.getIn(['search', props.dealType, 'filters', 'myDeals']),
  isArchived: state.getIn(['search', props.dealType, 'filters', 'isarchived']),
  dispute: state.getIn(['search', props.dealType, 'filters', 'dispute']),
  dealCanceled: state.getIn(['search', props.dealType, 'filters', 'dealCanceled']),
  unlinked: state.getIn(['search', props.dealType, 'filters', 'unlinked'], false),
  dealListSearch: state.getIn(['search', props.dealType, 'filters', 'dealListSearch'], ''),
  dataVersion: state.getIn(['search', props.dealType, 'dataVersion']),
  shipmentSort: state.getIn(['sort', props.dealType, 'shipmentSort'], false),
  operationUsers: state.getIn(['allaround', 'operations'], new Map()),
  charteringUsers: state.getIn(['allaround', 'chartering'], new Map()),
  traderUsers: state.getIn(['allaround', 'traders'], new Map()),
  operationUserId: state.getIn(['search', props.dealType, 'filters', 'operationUserId']),
  roles: state.getIn(['session', 'roles'], ''),
})),
(dispatch, props) => (
  {
    filterPaymentsData(archivedPayments) {
      filterPaymentsData(dispatch, archivedPayments);
    },
    filterDetachedPaymentsData() {
      filterDetachedPaymentsData(dispatch);
    },
    selectProductTypes(...types) {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        filterProductTypes(dispatch, types, 'purchase');
        filterProductTypes(dispatch, types, 'sale');
      } else {
        filterProductTypes(dispatch, types, props.dealType);
      }
    },
    selectTransportTypes(...types) {
      filterTransportTypes(dispatch, types, props.dealType);
    },
    selectMyDeals(value) {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        filterMyDeals(dispatch, value, 'purchase');
        filterMyDeals(dispatch, value, 'sale');
      } else {
        filterMyDeals(dispatch, value, props.dealType);
      }
    },
    selectArchived(value) {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        filterIsArchived(dispatch, value, 'purchase');
        filterIsArchived(dispatch, value, 'sale');
      } else {
        filterIsArchived(dispatch, value, props.dealType);
      }
    },
    selectDealCanceled(value) {
      filterDealCanceled(dispatch, value);
    },
    selectDispute(value) {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        filterHasDispute(dispatch, value, 'purchase');
        filterHasDispute(dispatch, value, 'sale');
      } else {
        filterHasDispute(dispatch, value, props.dealType);
      }
    },
    resetFilters() {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        resetFilters(dispatch, 'purchase');
        resetFilters(dispatch, 'sale');
      } else {
        resetFilters(dispatch, props.dealType);
      }
    },
    filterDealData(myDeals, selectedTypes, dealType, transportTypes,
      isArchived, dispute, operationUserId, dealCanceled, dealSearch) {
      if (dealType) {
        if (dealType == 'transport' || dealType == 'transportBulkPayment') {
          filterTransportData(dispatch, myDeals, selectedTypes,
            dealType, transportTypes, isArchived, dispute, operationUserId, dealSearch);
        } else {
          filterData(dispatch, myDeals, selectedTypes, 'purchase',
            isArchived, dispute, operationUserId, dealCanceled, dealSearch);
          filterData(dispatch, myDeals, selectedTypes, 'sale',
            isArchived, dispute, operationUserId, dealCanceled, dealSearch);
        }
      }
    },
    filterUnlinked(value) {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        filterUnlinked(dispatch, value, 'purchase');
        filterUnlinked(dispatch, value, 'sale');
      } else {
        filterUnlinked(dispatch, value, props.dealType);
      }
    },
    selectOperationUser(id) {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        filterOperationDeals(dispatch, 'purchase', id);
        filterOperationDeals(dispatch, 'sale', id);
      } else {
        filterOperationDeals(dispatch, props.dealType, id);
      }
    },
    selectShipmentSort(value) {
      if (props.dealType == 'sale' || props.dealType == 'purchase') {
        selectShipmentSort(dispatch, value, 'purchase');
        selectShipmentSort(dispatch, value, 'sale');
      } else {
        selectShipmentSort(dispatch, value, props.dealType);
      }
    },
    loadAllOperators() {
      loadOperationUsers(dispatch);
    },
    loadAllChartering() {
      loadCharteringUsers(dispatch);
    },
    loadTraderUsers() {
      loadTraderUsers(dispatch);
    },
    updateDealListSearch(value) {
      updateDealListSearch(dispatch, props.dealType, value);
    },
  }
))(FilterPanel);
